import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack, IoSettingsOutline } from "react-icons/io5";
import { updateUser } from "../api";
import "../styles/sifaris.css";

const SettingsScreen = () => {
  const navigate = useNavigate();

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [resultModal, setResultModal] = useState({
    open: false,
    title: "",
    message: "",
    type: "info",
  });

  const handleDeleteAccount = async () => {
    try {
      setDeleting(true);

      const userId = localStorage.getItem("id");
      if (!userId) {
        setResultModal({
          open: true,
          title: "Xəta",
          message: "İstifadəçi tapılmadı.",
          type: "error",
        });
        setDeleting(false);
        return;
      }

      await updateUser(userId, { isDisable: true });

      setConfirmDeleteOpen(false);
      setDeleting(false);

      setResultModal({
        open: true,
        title: "Uğur",
        message: "Hesabınız silindi.",
        type: "success",
      });
    } catch (error) {
      console.error("Hesabı silərkən xəta baş verdi:", error);
      setDeleting(false);
      setConfirmDeleteOpen(false);

      setResultModal({
        open: true,
        title: "Xəta",
        message: "Hesabı silmək mümkün olmadı.",
        type: "error",
      });
    }
  };

  const handleResultClose = () => {
    const isSuccess = resultModal.type === "success";

    setResultModal({
      open: false,
      title: "",
      message: "",
      type: "info",
    });

    if (isSuccess) {
      localStorage.clear();
      navigate("/sifaris/login", { replace: true });
    }
  };

  return (
    <div className="sq-settings-page">
        
      <div className="sq-settings-card">
        <button
          type="button"
          className="sq-settings-back-btn"
          onClick={() => navigate(-1)}
        >
          <IoArrowBack size={18} />
          <span>Geri</span>
        </button>

        <div className="sq-settings-icon-wrap">
          <IoSettingsOutline size={28} />
        </div>

        <h1 className="sq-settings-title">⚙️ Parametrlər</h1>

        <button
          type="button"
          className="sq-settings-delete-btn"
          onClick={() => setConfirmDeleteOpen(true)}
        >
          Hesabı Sil
        </button>
      </div>

      {confirmDeleteOpen && (
        <div className="sq-modal-overlay">
          <div className="sq-alert-modal">
            <h3 className="sq-alert-title sq-alert-warning">Hesabı Sil</h3>
            <p className="sq-alert-message">
              Hesabınızı tamamilə silmək istəyirsiniz?
            </p>

            <div className="sq-alert-actions">
              <button
                type="button"
                className="sq-alert-button sq-alert-button-secondary"
                onClick={() => setConfirmDeleteOpen(false)}
                disabled={deleting}
              >
                Xeyr
              </button>

              <button
                type="button"
                className="sq-alert-button sq-alert-button-danger"
                onClick={handleDeleteAccount}
                disabled={deleting}
              >
                {deleting ? "Silinir..." : "Bəli"}
              </button>
            </div>
          </div>
        </div>
      )}

      {resultModal.open && (
        <div className="sq-modal-overlay">
          <div className="sq-alert-modal">
            <h3 className={`sq-alert-title sq-alert-${resultModal.type}`}>
              {resultModal.title}
            </h3>
            <p className="sq-alert-message">{resultModal.message}</p>

            <button
              type="button"
              className="sq-alert-button"
              onClick={handleResultClose}
            >
              Bağla
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingsScreen;